import { split } from "lodash";
import { useLocation } from "react-router-dom";
import { PageLoading, TypedResolver } from "src/components";

import {
  loadBulkyItemsTypes,
  loadCategoryTypes,
  loadCitySettings,
  loadPeriodTypes,
  loadScheduledItem,
  setConfirmationId,
  validateVendorURL,
} from "src/redux/reducers";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import SchedulerWizardPage from "./SchedulerWizardPage";

const SchedulerSummaryPageResolver = () => {
  const { confirmationId } = useAppSelector(
    (state) => state.bulkyItemsScheduler
  );

  const dispatch = useAppDispatch();
  const { pathname, state } = useLocation();
  const vendorURL = split(pathname, "/")[1];

  // requestId
  const requestId = split(pathname, "/")[3];

  const loadDependencies = async () => {
    if (vendorURL && requestId) {
      const dependencies: (
        | Promise<any>
        | { payload: any; type: "bulkyItemsScheduler/setConfirmationId" }
      )[] = [
        loadCitySettings()(dispatch),
        loadPeriodTypes()(dispatch),
        loadBulkyItemsTypes()(dispatch),
        loadCategoryTypes()(dispatch),
      ];

      const isValid = await validateVendorURL(vendorURL)(dispatch);
      if (!isValid) return Promise.reject();

      const item = await loadScheduledItem(requestId, vendorURL)(dispatch);
      if (!item) return Promise.reject();

      if (confirmationId !== requestId) {
        dependencies.push(dispatch(setConfirmationId(requestId)));
      }

      return Promise.all(dependencies);
    } else {
      return Promise.reject();
    }
  };

  return (
    <TypedResolver
      successComponent={SchedulerWizardPage}
      resolve={loadDependencies}
      successProps={{
        isSummary: true,
        isFromConfirmation: state?.isFromConfirmation,
      }}
      loadingComponent={PageLoading}
      redirectOnError={`/`}
    />
  );
};

export default SchedulerSummaryPageResolver;
